import React, { useState } from "react";
import {
  Button,
  DownloadIcon,
  Pane,
  Strong,
  Text,
  TextInputField,
} from "evergreen-ui";
import { SketchPicker } from "react-color";
import QRCode from "qrcode.react";
import { Container, Row, Col } from "react-grid-system";

const App = () => {
  const [value, setValue] = useState("");
  const [color, setColor] = useState("#000000");

  const handleColorChange = (color) => {
    setColor(color.hex);
  };

  const downloadQRCode = () => {
    const qrCodeURL = document
      .getElementById("qrcode")
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    console.log(qrCodeURL);
    let x = document.createElement("a");
    x.href = qrCodeURL;
    x.download = "QR_Code.png";
    document.body.appendChild(x);
    x.click();
    document.body.removeChild(x);
  };

  return (
    <Container fluid>
      <Row align="center" justify="center">
        <Text marginX={12} marginY={20} textAlign={"center"}>
          <Strong fontSize={24}>QR Code Generator</Strong>
        </Text>
      </Row>
      <Row align="start" justify="center" style={{ margin: "20px 0px" }}>
        <Col xs={12} sm={6} md={6} lg={4} align="center" justify="center">
          <Pane
            elevation={2}
            marginBottom={16}
            padding={16}
            borderRadius={5}
            float={"center"}
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="flex-start"
            border="none"
          >
            <TextInputField
              width={"75%"}
              isInvalid={value ? false : true}
              label="Enter Some Value"
              description="Text, URL, Number etc."
              value={value}
              onChange={(event) => setValue(event.target.value)}
            />
            {value && (
              <>
                <QRCode
                  id="qrcode"
                  value={value}
                  fgColor={color}
                  includeMargin={true}
                  imageSettings={{ width: 300, height: 300 }}
                />
                <Button
                  paddingX={20}
                  marginY={5}
                  intent="success"
                  appearance="primary"
                  onClick={downloadQRCode}
                >
                  <DownloadIcon marginRight={8} />
                  Download
                </Button>
              </>
            )}
          </Pane>
        </Col>
        <Col xs={12} sm={6} md={6} lg={4} align="center" justify="center">
          <SketchPicker color={color} onChangeComplete={handleColorChange} />
        </Col>
      </Row>
    </Container>
  );
};

export default App;
